var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "stepsHeading"
  }, [_vm._v("Choose any one of the options:")]), _c('div', {
    staticClass: "cardsWrpr d-flex justify-content-between align-items-center flex-wrap m-auto"
  }, [_vm.getError('migration_platform') ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(" You need to select platform to migrate from. ")]) : _vm._e(), _c('label', {
    class: {
      active: _vm.migration_platform === 'Strava'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.migration_platform,
      expression: "migration_platform"
    }],
    attrs: {
      "type": "radio",
      "name": "migration_platform",
      "value": "Strava"
    },
    domProps: {
      "checked": _vm._q(_vm.migration_platform, "Strava")
    },
    on: {
      "change": function ($event) {
        _vm.migration_platform = "Strava";
      }
    }
  }), _c('img', {
    attrs: {
      "src": "/assets/images/steps-form-logos/strava.png",
      "alt": "strava import"
    }
  })]), _c('label', {
    class: {
      active: _vm.migration_platform === 'Zwift'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.migration_platform,
      expression: "migration_platform"
    }],
    attrs: {
      "type": "radio",
      "name": "migration_platform",
      "value": "Zwift"
    },
    domProps: {
      "checked": _vm._q(_vm.migration_platform, "Zwift")
    },
    on: {
      "change": function ($event) {
        _vm.migration_platform = "Zwift";
      }
    }
  }), _c('img', {
    attrs: {
      "src": "/assets/images/steps-form-logos/zwift.png",
      "alt": "swift import"
    }
  })]), _c('label', {
    class: {
      active: _vm.migration_platform === 'Trainer road'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.migration_platform,
      expression: "migration_platform"
    }],
    attrs: {
      "type": "radio",
      "name": "migration_platform",
      "value": "Trainer road"
    },
    domProps: {
      "checked": _vm._q(_vm.migration_platform, "Trainer road")
    },
    on: {
      "change": function ($event) {
        _vm.migration_platform = "Trainer road";
      }
    }
  }), _c('img', {
    attrs: {
      "src": "/assets/images/steps-form-logos/tr_updated.png",
      "alt": "trainer road import"
    }
  })]), _c('label', {
    class: {
      active: _vm.migration_platform === 'Rouvy'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.migration_platform,
      expression: "migration_platform"
    }],
    attrs: {
      "type": "radio",
      "name": "migration_platform",
      "value": "Rouvy"
    },
    domProps: {
      "checked": _vm._q(_vm.migration_platform, "Rouvy")
    },
    on: {
      "change": function ($event) {
        _vm.migration_platform = "Rouvy";
      }
    }
  }), _c('img', {
    attrs: {
      "src": "/assets/images/steps-form-logos/rouvy.png",
      "alt": "rouvy import"
    }
  })]), _c('label', {
    class: {
      active: _vm.migration_platform === 'Bkool'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.migration_platform,
      expression: "migration_platform"
    }],
    attrs: {
      "type": "radio",
      "name": "migration_platform",
      "value": "Bkool"
    },
    domProps: {
      "checked": _vm._q(_vm.migration_platform, "Bkool")
    },
    on: {
      "change": function ($event) {
        _vm.migration_platform = "Bkool";
      }
    }
  }), _c('img', {
    attrs: {
      "src": "/assets/images/steps-form-logos/bkool.png",
      "alt": "bkool import"
    }
  })]), _c('label', {
    class: {
      active: _vm.migration_platform === 'Others'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.migration_platform,
      expression: "migration_platform"
    }],
    attrs: {
      "type": "radio",
      "name": "migration_platform",
      "value": "Others"
    },
    domProps: {
      "checked": _vm._q(_vm.migration_platform, "Others")
    },
    on: {
      "change": function ($event) {
        _vm.migration_platform = "Others";
      }
    }
  }), _c('img', {
    attrs: {
      "src": "/assets/images/steps-form-logos/others.png",
      "alt": "others import"
    }
  })])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }